        //スムーズスクロール
        $('a[href*="#"]:not([href="#recover"],a[href="#login"])').click(function () {
            var speed = 1000;
            var headerHeight = 0;
            var href = $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top - headerHeight;
            $("html, body").animate({
                scrollTop: position
            }, speed, "swing");
            return false;
        });
        //pcでtel無効
        var ua = navigator.userAgent;
        if (ua.indexOf('iPhone') < 0 && ua.indexOf('Android') < 0) {
            $('a[href^="tel:"]').css('cursor', 'default').click(function (event) {
                event.preventDefault();
            });
        }
        $(function () {
            var topBtn = $('.pagefor');
            topBtn.hide();
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    topBtn.fadeIn();
                } else {
                    topBtn.fadeOut();
                }
            });
            topBtn.click(function () {
                $('body,html').animate({
                    scrollTop: 0
                }, 500);
                return false;
            });
        });